(function (module) {
    'use strict';

    function MyAccountCtrl(Account, User, Includes, $timeout, $state, Store) {
        this.$onInit = () => {
            this.copied = false;

            User.getCurrent({ filter: Includes.users }).$promise.then((user) => {
                Store.setCurrentAccount(user.account);
                Store.setCurrentUser(user);
                this.user = Store.getCurrentUser()
                this.account = Store.getCurrentAccount()
            });
        };
    }

    module
        .config(function ($stateProvider, $translatePartialLoaderProvider) {
            // Route
            $stateProvider.state('root.my-account', {
                url: '/my-account',
                data: {
                    pageTitle: 'MY_ACCOUNT.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<my-account-component />',
                    },
                },
                bodyClass: 'page--myAccount',
            });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/my-account');
        })

        .component('myAccountComponent', {
            templateUrl: '/js/my-account/my-account.html',
            controller: MyAccountCtrl,
        });
})(angular.module('rocket.components'));
